import React, { useEffect, useRef, useState } from "react";
import { FilterParams, Search } from "../../hook";
import Arrow from "../Arrow/Arrow";
import styles from "./index.module.less";
import { disableScroll, enableScroll } from "./utils";

interface Props {
  filter: FilterParams;
  searchParams: Search;
  fixed: boolean;
  setSearchParams: (params: Search) => void;
  handleSearch: (params?: Search, init?: boolean) => void;
  brandList: any[];
  priceRangeList: any[];
}

const Filter: React.FC<Props> = props => {
  const { filter, searchParams, brandList, priceRangeList, fixed } = props;
  const [showModal, setShowModal] = useState<string>("");
  const scrollView = useRef<HTMLElement | null>(null);

  // 滚动到筛选组件顶部
  const scrollToFilter = () => {
    try {
      // 直接设置滚动容器的scrollTop
      const scrollElement = document.getElementById("reward-gift-scrollview");
      if (scrollElement) {
        scrollView.current = scrollElement;
        // 获取headerWrapper的高度
        const headerWrapper = document.querySelector(".headerWrapper");
        if (headerWrapper) {
          // 设置滚动位置
          const scrollPosition = headerWrapper.clientHeight;
          console.log("滚动到位置:", scrollPosition);

          // 使用setTimeout确保DOM已更新
          setTimeout(() => {
            scrollElement.scrollTo(0, scrollPosition);
          }, 100);
        }
      }
    } catch (error) {
      console.error("滚动到筛选区域失败:", error);
    }
  };

  // 关闭弹窗
  const closeModal = () => {
    setShowModal("");
    enableScroll();
  };

  // 提交筛选
  const handleSubmit = (type: "brand" | "price") => {
    let params: any = searchParams;
    if (type === "price" && !searchParams.price) {
      params = {
        all: undefined,
        sale: undefined,
        brand: undefined,
        price: undefined,
      };
      params.price = {
        name: "all",
        min: 0,
      };
    }
    if (type === "brand" && !searchParams.brand) {
      params = {
        all: undefined,
        sale: undefined,
        brand: undefined,
        price: undefined,
      };
      params.brand = [];
    }
    props.handleSearch(params, true);
    closeModal();

    // 自动滚动到筛选顶部
    scrollToFilter();
  };

  // 重置筛选
  const resetFilter = (type: "brand" | "price") => {
    if (type === "brand") {
      const params = {
        ...searchParams,
        all: undefined,
        sale: undefined,
        brand: undefined,
        price: undefined,
      };
      props.setSearchParams(params);
    }
    if (type === "price") {
      const params = {
        ...searchParams,
        all: undefined,
        sale: undefined,
        brand: undefined,
        price: undefined,
      };
      props.setSearchParams(params);
    }
  };

  // 点击筛选框
  const clickFilter = (key: string) => {
    // 如果当前有显示的弹窗，先关闭它
    if (showModal) {
      closeModal();
    }

    disableScroll();

    let params: Search = {
      all: undefined,
      sale: undefined,
      brand: undefined,
      price: undefined
    };

    if (key === "all") {
      // 点击综合
      params.all = "down";
      closeModal();
      props.setSearchParams(params);
      props.handleSearch(params, true);
    } else if (key === "sale") {
      // 点击销量
      if (filter.sale === "down") {
        params.sale = "up";
      } else {
        params.sale = "down";
      }
      closeModal();
      props.setSearchParams(params);
      props.handleSearch(params, true);
    } else if (key === "brand") {
      if (showModal === "brand") {
        closeModal();
        return;
      }
      setShowModal("brand");
      // 自动滚动到筛选顶部
      scrollToFilter();
      return;
    } else if (key === "price") {
      if (showModal === "price") {
        closeModal();
        return;
      }
      setShowModal("price");
      // 自动滚动到筛选顶部
      scrollToFilter();
      return;
    }

    // 自动滚动到筛选顶部
    scrollToFilter();
  };

  // 选择品牌
  const handleBrand = (item: any) => {
    const brandId = item.brandId;
    let brand = searchParams.brand || [];
    if (brand.includes(brandId)) {
      brand = brand.filter(item => item !== brandId);
    } else {
      brand.push(brandId);
    }
    const params = { ...searchParams };
    Object.keys(searchParams).forEach(key => {
      if (key === "brand") {
        params[key] = brand;
      } else {
        params[key] = undefined;
      }
    });
    props.setSearchParams(params);
  };

  // 选择价格
  const handlePrice = (item: any) => {
    const params: any = {
      all: undefined,
      sale: undefined,
      price: undefined,
      brand: undefined,
    };
    params.price = item;
    props.setSearchParams(params);
  };

  // 输入价格
  const inputPrice = (type: "min" | "max", e: any) => {
    const price = { min: 0, max: 0 };
    const name = (searchParams as any).price?.name || "";
    if (type === "min") {
      price.min = e.target.value.replace(/[^\d{1,}]/g, "").slice(0, 6);
      price.max = name ? "" : (searchParams as any).price?.max;
    }
    if (type === "max") {
      price.min = name ? "" : (searchParams as any).price?.min;
      price.max = e.target.value.replace(/[^\d{1,}]/g, "").slice(0, 6);
    }
    const params = {
      all: undefined,
      sale: undefined,
      brand: undefined,
      price: price,
    };
    props.setSearchParams(params);
  };

  // 阻止事件冒泡
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  // 处理弹窗内的触摸事件，防止滚动穿透
  const handleTouchMove = (e: React.TouchEvent) => {
    if (showModal) {
      e.stopPropagation();
    }
  };

  // 价格弹框
  const priceDom = () => {
    const price: any = searchParams.price || {};
    const { name = "", min = "", max = "" } = price;
    return (
      <div className={styles.priceBox}>
        <div className={styles.priceItemBox}>
          {priceRangeList.map((item, index) => {
            return (
              <div
                className={`${styles.priceItem} ${(price as any)?.name === item.name ? styles.price_active : ""}`}
                key={index}
                onClick={() => {
                  handlePrice(item);
                }}>
                {item.name}
              </div>
            );
          })}
        </div>
        <div className={styles.price_range}>
          <input
            placeholder={"最低价"}
            className={styles.priceInput}
            value={name ? "" : min}
            onInput={e => {
              inputPrice("min", e);
            }}
          />
          <div className={styles.price_line}></div>
          <input
            placeholder={"最高价"}
            className={styles.priceInput}
            value={name ? "" : max}
            onInput={e => {
              inputPrice("max", e);
            }}
          />
        </div>
        <div className={styles.price_bottom}>
          <div
            className={styles.price_reset}
            onClick={() => {
              resetFilter("price");
            }}>
            重置
          </div>
          <div
            onClick={() => {
              handleSubmit("price");
            }}
            className={styles.price_confirm}>
            确定
          </div>
        </div>
      </div>
    );
  };

  // 品牌弹框
  const brandModal = () => {
    return (
      <div
        className={styles.brandContainer}
        onClick={stopPropagation}
        onTouchMove={handleTouchMove}
      >
        <div className={styles.brandBox}>
          {brandList.map(item => {
            return (
              <div
                className={`${styles.brandItem} ${(searchParams.brand || []).includes(item.brandId) ? styles.item_active : ""}`}
                key={item.brandId}
                onClick={() => handleBrand(item)}>
                <img className={styles.brandIcon} src={item.brandLogo} alt={""} />
                <div className={styles.brandName}>{item.brandName}</div>
              </div>
            );
          })}
        </div>
        <div className={styles.brandBottom}>
          <div
            className={styles.brandReset}
            onClick={() => {
              resetFilter("brand");
            }}>
            重置
          </div>
          <div
            className={styles.brandConfirm}
            onClick={() => {
              handleSubmit("brand");
            }}>
            确定
          </div>
        </div>
      </div>
    );
  };

  // 箭头样式
  const arrowStyle = (item: string) => {
    const typeMap = {
      sale: "double",
      price: "single",
      brand: "single",
    };
    const directionMap = {
      up: "up",
      down: "down",
      false: "default",
    };
    return {
      type: typeMap[item],
      direction: directionMap[filter[item].toString()],
    };
  };

  // 组件挂载后，添加点击事件处理
  useEffect(() => {
    // 确保滚动容器存在时添加激活吸顶的点击事件
    const activateSticky = () => {
      try {
        // 获取滚动容器
        const scrollElement = document.getElementById("reward-gift-scrollview");
        if (scrollElement) {
          scrollView.current = scrollElement;
        }
      } catch (error) {
        console.error("获取滚动容器失败:", error);
      }
    };

    // 为筛选选项添加点击事件
    const filterItems = document.querySelectorAll(`.${styles.filterItem}`);
    filterItems.forEach(item => {
      item.addEventListener("click", activateSticky);
    });

    // 组件卸载时移除事件监听
    return () => {
      filterItems.forEach(item => {
        item.removeEventListener("click", activateSticky);
      });
    };
  }, []);

  return (
    <div className={`${styles.filterContainer} ${fixed ? styles.noRadius : ""}`}>
      <a href={"#bottomBox"}>
        <div className={styles.filterBox}>
          <div
            onClick={() => {
              clickFilter("all");
            }}
            className={`${styles.filterItem} ${filter.all ? styles.item_active : ""}`}>
            综合
          </div>
          <div
            onClick={() => {
              clickFilter("sale");
            }}
            className={`${styles.filterItem} ${filter.sale ? styles.item_active : ""}`}>
            销量
            <Arrow type={arrowStyle("sale").type} direction={arrowStyle("sale").direction} />
          </div>
          <div
            onClick={() => {
              clickFilter("price");
            }}
            className={`${styles.filterItem} ${filter.price ? styles.item_active : ""}`}>
            价格
            <Arrow type={arrowStyle("price").type} direction={arrowStyle("price").direction} />
          </div>
          <div
            onClick={() => {
              clickFilter("brand");
            }}
            className={`${styles.filterItem} ${filter.brand ? styles.item_active : ""}`}>
            品牌
            <Arrow type={arrowStyle("brand").type} direction={arrowStyle("brand").direction} />
          </div>
        </div>
      </a>
      <div className={styles.contentBox}>
        {showModal === "price" && priceDom()}
        {showModal === "brand" && brandModal()}
      </div>
      {showModal && (
        <div
          className={styles.mask}
          onClick={e => {
            e.stopPropagation();
            closeModal();
          }}></div>
      )}
    </div>
  );
};

export default Filter;
